import React from "react";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import styles from "./FlashAssistant.module.scss";

function formatTime(value) {
  if (!value) return "";
  try {
    return new Date(value).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return value;
  }
}

export default function RightPanel({
  rightPanelOpen,
  onToggle,
  conversations = [],
  activeConversationId,
  onSelectConversation,
  onCreateConversation,
  usage,
}) {
  return (
    <>
      {!rightPanelOpen && (
        <button
          type="button"
          className={styles.expandButton}
          onClick={onToggle}
          aria-label="Expand panel"
        >
          <KeyboardDoubleArrowLeftIcon fontSize="small" />
        </button>
      )}
      <div
        className={
          rightPanelOpen ? styles.rightPanel : `${styles.rightPanel} ${styles.rightPanelCollapsed}`
        }
      >
        <div className={styles.panelHeader}>
          <span className={styles.panelTitle}>Abyss Insights</span>
          <button
            type="button"
            className={styles.toggleButton}
            onClick={onToggle}
            aria-label="Collapse panel"
          >
            <KeyboardDoubleArrowRightIcon fontSize="small" />
          </button>
        </div>
        <div className={styles.panelBody}>
          <div className={styles.sidebarTop}>
            <span className={styles.sidebarTopLabel}>Chats</span>
          </div>
          <div className={styles.historySection}>
            <div className={styles.historyList}>
              <button
                type="button"
                className={`${styles.historyItem} ${!activeConversationId ? styles.historyItemActive : ""}`}
                onClick={onCreateConversation}
              >
                + New chat
              </button>
              {conversations.map((conv) => {
                const active = conv.id === activeConversationId;
                return (
                  <button
                    key={conv.id}
                    type="button"
                    className={`${styles.historyItem} ${active ? styles.historyItemActive : ""}`}
                    onClick={() => onSelectConversation(conv)}
                  >
                    {conv.title || "Untitled"}
                    <span className="d-block small text-muted mt-1">
                      {formatTime(conv.last_message_at)}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className={styles.usageCard}>
            <div className={styles.usageCardTitle}>Usage</div>
            <div className={styles.usageBar}>
              <div
                className={styles.usageBarFill}
                style={{ width: `${Math.min(100, usage?.token_percent || 0)}%` }}
              />
            </div>
            <div className={styles.usageLabel}>
              {usage?.used_tokens ?? 0} / {usage?.max_tokens ?? "—"} tokens
            </div>
            <div className={styles.usageLabel}>
              ${Number(usage?.used_cost ?? 0).toFixed(2)}
              {usage?.max_cost != null ? ` / $${Number(usage.max_cost).toFixed(2)}` : ""} cost
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
